<template>
    <div>
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">SAC</h1>

        </div>

        <ul class="nav nav-tabs" role="tablist" style="margin-bottom: 5px;">
            <li class="nav-item">
                <router-link :to="{ name: 'Elogios', params: { get: 'Elogios' } }" class="nav-link active"
                    data-toggle="tab">Elogios</router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{ name: 'Duvidas', params: { get: 'Duvidas' } }" class="nav-link"
                    data-toggle="tab">Dúvidas</router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{ name: 'Reclamacoes', params: { get: 'Reclamacoes' } }" class="nav-link"
                    data-toggle="tab">Reclamações</router-link>
            </li>
        </ul>

        <router-view></router-view>

    </div>

</template>

<script>


export default {
    name: "SAC",
    props: ["get"],

    beforeRouteUpdate(to, from, next) {
        next();
    },

    data() {
        return {
            
        }
    },

};
</script>

<style></style>